import { FunctionComponent, memo, SyntheticEvent } from 'react';
import { Case as CaseType } from '~types';
import dayjs from 'dayjs';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import { useProfile } from '../../profile/hooks';
import { useConfig } from '~components/hooks';
import { useTranslation } from 'react-i18next';
import Currency from '~components/Currency';
import FormatDate from './FormatDate';
import { useYaMetrica } from '~frontend/provider/yametrica';
import { convertNumber } from '~ui/Price';
import { Button } from '~shared/frontend/ui/button/button';
import { useStatusGame } from '../hooks';

interface FreeCaseButtonProps {
  getCase: CaseType;
}

const FreeCaseButton: FunctionComponent<FreeCaseButtonProps> = ({
  getCase,
}) => {
  const getConfig = useConfig();
  const getProfile = useProfile();
  const yametrica = useYaMetrica();
  const { t } = useTranslation();
  const [gameStatus] = useStatusGame();

  //to check
  const reachGoal = (event: SyntheticEvent<HTMLElement>) => {
    const dataset =
      event.currentTarget?.dataset || (event.target as HTMLElement)?.dataset;

    const reachgoal = dataset?.reachgoal;

    if (reachgoal) {
      yametrica.reachGoal(reachgoal);
    }
  };

  const amount =
    getCase?.seo?.inputMoney - (getConfig?.getCurrency?.id === 11 ? 0.1 : 1);

  return (
    <>
      <div
        className="case_actions free_case_margin_mob"
        style={{ display: `${gameStatus === 4 ? 'none' : 'flex'}` }}
      >
        <div className="case_actions_balance">
          <span>{t('Great prize! Get it')},</span> {getCase?.seo?.inputMoney}{' '}
          <Currency isText={true} /> <span>{t('to the account')}</span>
          <span>{t('and')} </span> 30 {t('free_case_opening_descrip')}{' '}
          <span>
            {t('this free case')} {t('for a present')}!
          </span>
        </div>
        {/* <FormatDate
          getDateEnd={dayjs(getCase?.getActiveGame?.createdAt)
            .add(4, 'hours')
            .format()}
        /> */}

        <div className="case_opened_left_group"></div>
        <div className="case_opened_center_group">
          {' '}
          <Button
            className="btn1_yellow case_actions_button"
            href="/pay"
            state={{
              amount,
            }}
            text={`${t('Get for')} ${amount}`}
            currencyComponent={<Currency />}
            onClick={reachGoal}
            data-reachgoal="FundsFreeCase"
          >
            {/* <div className="top"></div>
          <div className="top-2"></div>
          <div className="bot"></div>
          <div className="bot-2"></div>
          <div className="shadow"></div>
          <div className="shadow-2"></div>
          <div className="text">
            {t('Get for')} {amount} <Currency />
          </div> */}
          </Button>
        </div>

        <div className="case_opened_right_group"></div>

        {/* <div className="case-free-count">
          <div className="case-free-count-text">
            <div className="num">{getCase?.countOpen}</div>
            <div className="text">{t('free_buy_stats')}</div>
          </div>
          <div className="descr">{t('free_last_day')}</div>
        </div> */}
      </div>

      {/* <div className="case-free-descr">
        <div className="text">{t('free_get_it')}</div>
        <div className="text-yellow">
          {t('free_sum_profit')}{' '}
          {_.round(
            ((getCase?.seo?.inputMoney - convertNumber(getProfile.inputMoney)) /
              ((getCase?.seo?.inputMoney +
                convertNumber(getProfile.inputMoney)) /
                2)) *
              100 +
              100,
            2,
          )}
          %!
        </div>
      </div> */}
    </>
  );
};

export default memo(FreeCaseButton);
